export function getVerificationTokenById(send) {
  return (tokenId, ...args) =>
    send(
      {
        path: '/v1/tokens/{tokenId}',
        pathParameters: { tokenId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
